var _rect, _rect2, _path, _rect3, _path2, _rect4, _path3, _rect5, _path4, _rect6, _path5, _path6, _path7, _rect7, _rect8, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g, _path23, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPig404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 190,
    viewBox: "0 0 284 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 129.332,
    y: 78.0292,
    width: 14,
    height: 44,
    rx: 5,
    transform: "rotate(-27.2866 129.332 78.0292)",
    fill: "#715542"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 121.418,
    y: 88.8629,
    width: 14,
    height: 38,
    rx: 5,
    transform: "rotate(-117.287 121.418 88.8629)",
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.672 128.51C249.672 153.816 229.733 158.816 208.199 158.573C187.031 158.334 168.99 156.099 168.99 128.51C168.99 100.922 183.135 80.5551 208.199 80.5551C233.263 80.5551 249.672 100.922 249.672 128.51Z",
    fill: "#FEB2C9",
    fillOpacity: 0.99
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 26.5516,
    height: 46.5799,
    transform: "matrix(-0.997832 0.0658105 0.0658105 0.997832 239.68 124.206)",
    fill: "#4186EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.172 173.806C216.435 178.621 222.499 180.573 225.521 176.816V176.816C227.454 174.414 231.029 174.181 233.256 176.313L233.425 176.475C237.011 179.908 242.948 177.178 242.677 172.222L242.31 165.525L215.798 166.975L216.172 173.806Z",
    fill: "#CC748F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 217.214,
    y: 107.097,
    width: 26.5516,
    height: 46.5799,
    transform: "rotate(-53.4971 217.214 107.097)",
    fill: "#FEB2C9",
    fillOpacity: 0.99
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M271.65 114.139C275.558 116.964 273.921 123.12 269.127 123.631V123.631C266.061 123.958 263.933 126.84 264.522 129.866L264.567 130.096C265.516 134.968 260.01 138.487 255.987 135.579L250.551 131.65L266.105 110.131L271.65 114.139Z",
    fill: "#CC748F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 26.5516,
    height: 46.5799,
    transform: "matrix(-0.377579 -0.925977 -0.925977 0.377579 201.769 111.458)",
    fill: "#FEB2C9",
    fillOpacity: 0.99
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.283 104.818C142.797 106.588 142.86 112.958 147.38 114.639V114.639C150.269 115.714 151.618 119.033 150.299 121.819L150.199 122.031C148.074 126.517 152.539 131.288 157.157 129.465L163.395 127.003L153.646 102.306L147.283 104.818Z",
    fill: "#CC748F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 26.5516,
    height: 46.5799,
    transform: "matrix(-0.972456 -0.233088 -0.233088 0.972456 210.922 129.008)",
    fill: "#4186EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.761 169.405C172.585 174.081 177.797 177.743 181.797 175.052V175.052C184.355 173.331 187.838 174.169 189.333 176.866L189.447 177.071C191.853 181.412 198.332 180.566 199.543 175.752L201.18 169.248L175.431 162.77L173.761 169.405Z",
    fill: "#CC748F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250.393 128.553C250.393 150.204 230.403 159.098 208.812 158.891C187.589 158.686 166.613 152.157 166.613 128.553C170.224 81.4548 183.683 86.0713 208.812 86.0713C233.942 86.0713 250.393 81.4548 250.393 128.553Z",
    fill: "#AF3C3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M250.393 133.66C250.393 151.667 230.403 159.064 208.812 158.891C187.589 158.721 166.613 153.291 166.613 133.66C170.224 94.4892 183.683 98.3287 208.812 98.3287C233.942 98.3287 250.393 94.4892 250.393 133.66Z",
    fill: "#4186EE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 230.617,
    y: 83.7805,
    width: 15.8894,
    height: 22.3896,
    rx: 7.94471,
    transform: "rotate(26.0604 230.617 83.7805)",
    fill: "#4186EE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 15.8894,
    height: 22.3896,
    rx: 7.94471,
    transform: "matrix(-0.898332 0.439318 0.439318 0.898332 188.109 85.225)",
    fill: "#4186EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M209.323 28.1631L190.526 14.9017C190.526 14.9017 161.868 -1.23547 160.499 14.9017C159.13 31.0388 167.072 46.8059 167.072 46.8059L183.229 60.7727L209.323 28.1631Z",
    fill: "#F9A6BF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M200.104 28.9879L186.79 19.5941C186.79 19.5941 166.491 8.16347 165.521 19.5941C164.551 31.0248 170.176 42.1934 170.176 42.1934L181.621 52.0867L200.104 28.9879Z",
    fill: "#F37097"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M209.323 28.1631L228.119 14.9017C228.119 14.9017 256.777 -1.23547 258.146 14.9017C259.515 31.0388 251.573 46.8059 251.573 46.8059L235.416 60.7727L209.323 28.1631Z",
    fill: "#F9A6BF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M217.41 28.9879L230.724 19.5941C230.724 19.5941 251.024 8.16347 251.994 19.5941C252.964 31.0248 247.338 42.1934 247.338 42.1934L235.893 52.0867L217.41 28.9879Z",
    fill: "#F37097"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M254.421 60.0386C254.421 85.3438 229.725 90.344 208.191 90.1009C187.023 89.862 163.083 87.6271 163.083 60.0386C163.083 32.4501 183.127 12.0832 208.191 12.0832C233.255 12.0832 254.421 32.4501 254.421 60.0386Z",
    fill: "#F9A6BF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M177.449 49.8553C177.449 46.2296 180.389 43.2903 184.014 43.2903V43.2903C187.64 43.2903 190.579 46.2296 190.579 49.8553V49.8553C190.579 53.481 187.64 56.4202 184.014 56.4202V56.4202C180.389 56.4202 177.449 53.481 177.449 49.8553V49.8553Z",
    fill: "#EBEBEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M177.449 49.8553C177.449 46.2296 180.389 43.2903 184.014 43.2903V43.2903C187.64 43.2903 190.579 46.2296 190.579 49.8553V49.8553C190.579 53.481 187.64 56.4202 184.014 56.4202V56.4202C180.389 56.4202 177.449 53.481 177.449 49.8553V49.8553Z",
    fill: "#151414"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M188.01 70.4538C188.01 60.98 194.451 52.4784 203.868 51.4409C205.813 51.2267 207.713 51.0921 209.418 51.0921C211.123 51.0921 213.023 51.2267 214.967 51.4409C224.384 52.4784 230.825 60.98 230.825 70.4538V70.4538V70.4538C230.825 79.3604 223.605 86.5807 214.698 86.5807H209.418H204.137C195.231 86.5807 188.01 79.3604 188.01 70.4538V70.4538V70.4538Z",
    fill: "#EBEBEB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M188.01 70.4538C188.01 60.98 194.451 52.4784 203.868 51.4409C205.813 51.2267 207.713 51.0921 209.418 51.0921C211.123 51.0921 213.023 51.2267 214.967 51.4409C224.384 52.4784 230.825 60.98 230.825 70.4538V70.4538V70.4538C230.825 79.3604 223.605 86.5807 214.698 86.5807H209.418H204.137C195.231 86.5807 188.01 79.3604 188.01 70.4538V70.4538V70.4538Z",
    fill: "#CC748F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M196.002 66.648C196.002 64.2571 197.941 62.319 200.331 62.319V62.319C202.722 62.319 204.661 64.2571 204.661 66.648V71.1198C204.661 73.5106 202.722 75.4488 200.331 75.4488V75.4488C197.941 75.4488 196.002 73.5106 196.002 71.1198V66.648Z",
    fill: "#EBEBEB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M196.002 66.648C196.002 64.2571 197.941 62.319 200.331 62.319V62.319C202.722 62.319 204.661 64.2571 204.661 66.648V71.1198C204.661 73.5106 202.722 75.4488 200.331 75.4488V75.4488C197.941 75.4488 196.002 73.5106 196.002 71.1198V66.648Z",
    fill: "#7E4E5D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M213.414 66.648C213.414 64.2571 215.352 62.319 217.743 62.319V62.319C220.134 62.319 222.072 64.2571 222.072 66.648V71.1198C222.072 73.5106 220.134 75.4488 217.743 75.4488V75.4488C215.352 75.4488 213.414 73.5106 213.414 71.1198V66.648Z",
    fill: "#EBEBEB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M213.414 66.648C213.414 64.2571 215.352 62.319 217.743 62.319V62.319C220.134 62.319 222.072 64.2571 222.072 66.648V71.1198C222.072 73.5106 220.134 75.4488 217.743 75.4488V75.4488C215.352 75.4488 213.414 73.5106 213.414 71.1198V66.648Z",
    fill: "#7E4E5D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M228.256 49.8553C228.256 46.2296 231.195 43.2903 234.821 43.2903V43.2903C238.447 43.2903 241.386 46.2296 241.386 49.8553V49.8553C241.386 53.481 238.447 56.4202 234.821 56.4202V56.4202C231.195 56.4202 228.256 53.481 228.256 49.8553V49.8553Z",
    fill: "#EBEBEB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M228.256 49.8553C228.256 46.2296 231.195 43.2903 234.821 43.2903V43.2903C238.447 43.2903 241.386 46.2296 241.386 49.8553V49.8553C241.386 53.481 238.447 56.4202 234.821 56.4202V56.4202C231.195 56.4202 228.256 53.481 228.256 49.8553V49.8553Z",
    fill: "#151414"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0742 60.0533C63.9941 50.9878 77.0059 50.9878 81.9258 60.0533L121.134 132.299C125.835 140.961 119.564 151.5 109.708 151.5H31.2915C21.4359 151.5 15.1647 140.961 19.8657 132.299L59.0742 60.0533Z",
    fill: "#FAD462"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4375 119.031H66.9375L65.875 87.5H75.5L74.4375 119.031ZM70.6875 123.969C72.2083 123.969 73.4271 124.417 74.3438 125.312C75.2812 126.208 75.75 127.354 75.75 128.75C75.75 130.125 75.2812 131.26 74.3438 132.156C73.4271 133.052 72.2083 133.5 70.6875 133.5C69.1875 133.5 67.9688 133.052 67.0312 132.156C66.1146 131.26 65.6562 130.125 65.6562 128.75C65.6562 127.375 66.1146 126.24 67.0312 125.344C67.9688 124.427 69.1875 123.969 70.6875 123.969Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: 14.2733,
    y: 49.2542,
    width: 112.454,
    height: 106.246,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPig404);
export default __webpack_public_path__ + "static/media/pig-404.4365272c.svg";
export { ForwardRef as ReactComponent };